//* Shifts for Swarzedz

const shifts_8: ObjectI = {
  "1": "401-1-1",
  "2": "401-1-2",
  "3": "401-2-1",
  "4": "401-2-2",
  "5": "401-3-1",
  "6": "401-3-2",
  "7": "401-4-1",
  "8": "401-4-2",
  "9": "401-5-1",
  "10": "401-5-2",
  "54": "405-401-6",
  "21": "405-1-1",
  "22": "405-1-2",
  "23": "405-2-1",
  "24": "405-2-2",
  "25": "405-3-1",
  "26": "405-3-2",
  "27": "405-4-1",
  "28": "405-4-2",
  "29": "405-5-1",
  "30": "405-5-2",
  "13": "412-1-1",
  "14": "412-1-2",
  "15": "412-2-1",
  "16": "412-2-2",
  "17": "412-3-1",
  "18": "412-3-2",
  "41": "412-4-1",
  "42": "412-4-2",
  "43": "498-3-1",
  "39": "498-1",
  "40": "498-2",
  "44": "498-3-2",
  "35": "486-1",
  "36": "486-2",
  "33": "484-1",
  "34": "484-2",
  "46": "484-3",
  "31": "493-1",
  "32": "493-2",
  "19": "499-1",
  "20": "499-2",
  "37": "497-1",
  "38": "497-2",
  "49": "494-1-1",
  "50": "494-1-2",
  "51": "494-2-1",
  "52": "494-2-2",
  "11": "400-1",
  "12": "400-2",
  "55": "495",
};

const shifts_1_4: ObjectI = {
  "11": "400-1",
  "12": "400-2",
};

const shifts_56: ObjectI = {
  "11": "400-1",
  "12": "400-2",
};

const shifts_6: ObjectI = {
  "23": "401-1-1",
  "24": "401-1-2",
  "5": "401-2-1",
  "6": "401-2-2",
  "7": "401-3-1",
  "8": "401-3-2",
  "21": "405-1-1",
  "22": "405-1-2",
  "25": "405-2-1",
  "26": "405-2-2",
  "39": "405-3-1",
  "40": "405-3-2",
  "19": "484-1",
  "20": "484-2",
  "13": "412-1-1",
  "14": "412-1-2",
  "15": "412-2-1",
  "16": "412-2-2",
  "31": "493-1",
  "54": "485-1",
  "55": "493-2",
  "49": "494-1-1",
  "50": "494-1-2",
  "51": "494-2-1",
  "52": "494-2-2",
  "11": "400-1",
  "12": "400-2",
};

const shifts_7: ObjectI = {
  "7": "401-1-1",
  "8": "401-1-2",
  "9": "401-2-1",
  "10": "401-2-2",
  "23": "405-1-1",
  "24": "405-1-2",
  "25": "405-2-1",
  "26": "405-2-2",
  "19": "484-1",
  "20": "484-2",
  "15": "412-1-1",
  "16": "412-1-2",
  "17": "412-2-1",
  "18": "412-2-2",
  "31": "493-1",
  "55": "493-2",
  "49": "494-1-1",
  "50": "494-1-2",
  "51": "494-2-1",
  "52": "494-2-2",
  "11": "400-1",
  "12": "400-2",
};

const shifts_67: ObjectI = {
  "11": "400-1",
  "12": "400-2",
};

const shifts_78: ObjectI = {
  "11": "400-1",
  "12": "400-2",
};

const swarzedzShifts = [
  { shifts_8 },
  { shifts_1_4 },
  { shifts_56 },
  { shifts_6 },
  { shifts_7 },
  { shifts_67 },
  { shifts_78 },
];

export default swarzedzShifts;

//& Swarzedz Groups
export const treeGroupsDataSwarzedz = [
  {
    title: "Blok 400-1",
    key: "400-1",
    value: "400-1",
  },
  {
    title: "Blok 400-2",
    key: "400-2",
    value: "400-2",
  },
  {
    title: "Blok 400-1-1",
    key: "400-1-1",
    value: "400-1-1",
  },
  {
    title: "Blok 400-2-2",
    key: "400-2-2",
    value: "400-2-2",
  },
  {
    title: "Blok 405-401-6",
    key: "405-401-6",
    value: "405-401-6",
  },
  {
    title: "Blok 484-3",
    key: "484-3",
    value: "484-3",
  },
  {
    title: "Blok 485-1",
    key: "485-1",
    value: "485-1",
  },
  {
    title: "Blok S-4:40",
    key: "S-4:40",
    value: "S-4:40",
  },
  {
    title: "Blok 495",
    key: "495",
    value: "495",
  },
  {
    title: "Grupa 401-1",
    key: "401-1",
    value: "401-1",
    children: [
      {
        title: "401-1-1",
        key: "401-1-1",
        value: "401-1-1",
      },
      {
        title: "401-1-2",
        key: "401-1-2",
        value: "401-1-2",
      },
    ],
  },
  {
    title: "Grupa 401-2",
    key: "401-2",
    value: "401-2",
    children: [
      {
        title: "401-2-1",
        key: "401-2-1",
        value: "401-2-1",
      },
      {
        title: "401-2-2",
        key: "401-2-2",
        value: "401-2-2",
      },
    ],
  },
  {
    title: "Grupa 401-3",
    key: "401-3",
    value: "401-3",
    children: [
      {
        title: "401-3-1",
        key: "401-3-1",
        value: "401-3-1",
      },
      {
        title: "401-3-2",
        key: "401-3-2",
        value: "401-3-2",
      },
    ],
  },
  {
    title: "Grupa 401-4",
    key: "401-4",
    value: "401-4",
    children: [
      {
        title: "401-4-1",
        key: "401-4-1",
        value: "401-4-1",
      },
      {
        title: "401-4-2",
        key: "401-4-2",
        value: "401-4-2",
      },
    ],
  },
  {
    title: "Grupa 401-5",
    key: "401-5",
    value: "401-5",
    children: [
      {
        title: "401-5-1",
        key: "401-5-1",
        value: "401-5-1",
      },
      {
        title: "401-5-2",
        key: "401-5-2",
        value: "401-5-2",
      },
    ],
  },
  {
    title: "Grupa 405-1",
    key: "405-1",
    value: "405-1",
    children: [
      {
        title: "405-1-1",
        key: "405-1-1",
        value: "405-1-1",
      },
      {
        title: "405-1-2",
        key: "405-1-2",
        value: "405-1-2",
      },
    ],
  },
  {
    title: "Grupa 405-2",
    key: "405-2",
    value: "405-2",
    children: [
      {
        title: "405-2-1",
        key: "405-2-1",
        value: "405-2-1",
      },
      {
        title: "405-2-2",
        key: "405-2-2",
        value: "405-2-2",
      },
    ],
  },
  {
    title: "Grupa 405-3",
    key: "405-3",
    value: "405-3",
    children: [
      {
        title: "405-3-1",
        key: "405-3-1",
        value: "405-3-1",
      },
      {
        title: "405-3-2",
        key: "405-3-2",
        value: "405-3-2",
      },
    ],
  },
  {
    title: "Grupa 405-4",
    key: "405-4",
    value: "405-4",
    children: [
      {
        title: "405-4-1",
        key: "405-4-1",
        value: "405-4-1",
      },
      {
        title: "405-4-2",
        key: "405-4-2",
        value: "405-4-2",
      },
    ],
  },
  {
    title: "Grupa 405-5",
    key: "405-5",
    value: "405-5",
    children: [
      {
        title: "405-5-1",
        key: "405-5-1",
        value: "405-5-1",
      },
      {
        title: "405-5-2",
        key: "405-5-2",
        value: "405-5-2",
      },
    ],
  },
  {
    title: "Grupa 412-1",
    key: "412-1",
    value: "412-1",
    children: [
      {
        title: "412-1-1",
        key: "412-1-1",
        value: "412-1-1",
      },
      {
        title: "412-1-2",
        key: "412-1-2",
        value: "412-1-2",
      },
    ],
  },
  {
    title: "Grupa 412-2",
    key: "412-2",
    value: "412-2",
    children: [
      {
        title: "412-2-1",
        key: "412-2-1",
        value: "412-2-1",
      },
      {
        title: "412-2-2",
        key: "412-2-2",
        value: "412-2-2",
      },
    ],
  },
  {
    title: "Grupa 412-3",
    key: "412-3",
    value: "412-3",
    children: [
      {
        title: "412-3-1",
        key: "412-3-1",
        value: "412-3-1",
      },
      {
        title: "412-3-2",
        key: "412-3-2",
        value: "412-3-2",
      },
    ],
  },
  {
    title: "Grupa 412-4",
    key: "412-4",
    value: "412-4",
    children: [
      {
        title: "412-4-1",
        key: "412-4-1",
        value: "412-4-1",
      },
      {
        title: "412-4-2",
        key: "412-4-2",
        value: "412-4-2",
      },
    ],
  },
  {
    title: "Grupa 484",
    key: "484",
    value: "484",
    children: [
      {
        title: "484-1",
        key: "484-1",
        value: "484-1",
      },
      {
        title: "484-2",
        key: "484-2",
        value: "484-2",
      },
    ],
  },
  {
    title: "Grupa 486",
    key: "486",
    value: "486",
    children: [
      {
        title: "486-1",
        key: "486-1",
        value: "486-1",
      },
      {
        title: "486-2",
        key: "486-2",
        value: "486-2",
      },
    ],
  },
  {
    title: "Grupa 493",
    key: "493",
    value: "493",
    children: [
      {
        title: "493-1",
        key: "493-1",
        value: "493-1",
      },
      {
        title: "493-2",
        key: "493-2",
        value: "493-2",
      },
    ],
  },
  {
    title: "Grupa 494-1",
    key: "494-1",
    value: "494-1",
    children: [
      {
        title: "494-1-1",
        key: "494-1-1",
        value: "494-1-1",
      },
      {
        title: "494-1-2",
        key: "494-1-2",
        value: "494-1-2",
      },
    ],
  },
  {
    title: "Grupa 494-2",
    key: "494-2",
    value: "494-2",
    children: [
      {
        title: "494-2-1",
        key: "494-2-1",
        value: "494-2-1",
      },
      {
        title: "494-2-2",
        key: "494-2-2",
        value: "494-2-2",
      },
    ],
  },
  {
    title: "Grupa 497",
    key: "497",
    value: "497",
    children: [
      {
        title: "497-1",
        key: "497-1",
        value: "497-1",
      },
      {
        title: "497-2",
        key: "497-2",
        value: "497-2",
      },
    ],
  },
  {
    title: "Grupa 498",
    key: "498",
    value: "498",
    children: [
      {
        title: "498-1",
        key: "498-1",
        value: "498-1",
      },
      {
        title: "498-2",
        key: "498-2",
        value: "498-2",
      },
    ],
  },
  {
    title: "Grupa 498-3",
    key: "498-3",
    value: "498-3",
    children: [
      {
        title: "498-3-1",
        key: "498-3-1",
        value: "498-3-1",
      },
      {
        title: "498-3-2",
        key: "498-3-2",
        value: "498-3-2",
      },
    ],
  },
  {
    title: "Grupa 499",
    key: "499",
    value: "499",
    children: [
      {
        title: "499-1",
        key: "499-1",
        value: "499-1",
      },
      {
        title: "499-2",
        key: "499-2",
        value: "499-2",
      },
    ],
  },
];
